import { createStore } from 'vuex'
import router from '../modules/router'
import axios from 'axios'

import {disbursement} from './disbursement.module'
import {entity} from './entity.module'
import {user} from './user.module'
import {tree} from './tree.module'

const AUTH_REQUEST = 'authRequest'
const REG_REQUEST = 'REG_REQUEST'
const LOGOUT_REQUEST = 'logoutRequest'
const AUTH_SUCCESS = 'authSuccess'
const LOGOUT_SUCCESS = 'logoutSuccess'
const SESSION_EXPIRED = 'sessionExpired'
const AUTH_ERROR = 'authError'
const LANGUAGE_REQUEST = 'language'
const ORGANIZATION_REQUEST = 'ORGANIZATION_REQUEST'
const ORGANIZATION_SUCCESS = 'ORGANIZATION_SUCCESS'
const ORGANIZATION_SET = 'ORGANIZATION_SET'
const TREE_REQUEST = 'TREE_REQUEST'
const SHARE_REQUEST = 'SHARE_REQUEST'

const ALARM_REQUEST = 'ALARM_REQUEST'

const HEATMAP_REQUEST = 'HEATMAP_REQUEST'
const DASHBOARD_REQUEST = 'dashboard'

const BUILDING_REQUEST = 'BUILDIDING_REQUEST'
const HOMEBASE_REQUEST = 'HOMEBASE_REQUEST'
const VALVE_REQUEST = 'VALVE_REQUEST'

const VALVE_ALARM_REQUEST = 'VALVE_ALARM_REQUEST'
const UNIT_REQUEST = 'UNIT_REQUEST'
const TRANSMITTERS_REQUEST = 'TRANSMITTER_REQUEST'
const ELECTRICITY_METERS = 'ELECTRICITY_METERS'

const GAS_METERS = 'GAS_METERS'

const HEAT_METERS = 'HEAT_METERS'
const WATER_METERS = 'WATER_METERS'
const TIMEZONE_REQUEST = 'TIMEZONE_REQUEST'
const USER_REQUEST = 'USER_REQUEST'
const USER_SET = 'USER_SET'
const SHOW_UNIT = 'SHOW_UNIT'
const ALERT_REQUEST = 'ALERT_REQUEST'

const CLEAN_STATE = 'CLEAN_STATE'

const CHECK_API = 'CHECK_API'
const OPEN_VALVE_API = 'OPEN_VALVE_API'

// const DASHBOARD = 'dashboard'
const UNAUTHORIZED = 401

const LOGGED_IN = 'logged-in'
const LANGUAGE = 'language'

let timezones = null

const setItem = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value))
}

const getItem = (key) => {
    const item = localStorage.getItem(key)
    return item ? JSON.parse(item) : null
}

// root state object.
// each Vuex instance is just a single state tree.
const state = {
    status: '',
    login: getItem(LOGGED_IN) || false,
    organizations: getItem('organizations'),
    current: getItem('current'),
    userProfile: getItem('user')
}

const hasOrganization = (state) => {
    return Array.isArray(state.organizations) && state.organizations.length > 0
}

const handleError = (next, ignoreRedirect = false) => {
    return (error) => {
        const status = error && error.response && error.response.status
        if (status === UNAUTHORIZED && state.login) {
            state.login = false
            setItem(LOGGED_IN, false)
            if (!ignoreRedirect) {
                router.push('/login')
            }
        }
        if (next) {
            next(error)
        }
    }
}

const getLanguage = (language) => {
    if (language) {
        setItem(LANGUAGE, language)
    }
    language = getItem(LANGUAGE)
    if (language) {
        axios.defaults.params = {}
        axios.defaults.params.locale = language
    }
    return language
}
// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
    [AUTH_REQUEST] (state) {
        state.status = 'loading'
    },
    [AUTH_SUCCESS] (state) {
        state.login = true
        state.status = 'success'
        setItem(LOGGED_IN, true)
    },
    [AUTH_ERROR] (state) {
        state.status = 'error'
    },
    [LOGOUT_REQUEST] (state) {
        state.status = 'loading'
    },
    [LOGOUT_SUCCESS] (state) {
        state.staus = ''
        state.login = false
        setItem(LOGGED_IN, false)
    },
    [SESSION_EXPIRED] (state) {
        state.status = ''
        state.login = false
        state.organizations = null
        state.current = null
        state.userProfile = null
        setItem(LOGGED_IN, false)
        setItem('organizations', null)
        setItem('current', null)
        setItem('user', null)
    },
    [ORGANIZATION_SUCCESS] (state, payload) {
        state.organizations = payload.organizations
        let setCurrent = typeof payload.setCurrent == 'undefined' ? true : payload.setCurrent
        state.login = true
        if (setCurrent) {
            let organization = state.current = payload.organizations.length > 0 ? payload.organizations[0] : null
            setItem('current', organization)
        }
        setItem('organizations', payload.organizations)
    },
    [ORGANIZATION_SET] (state, organization) {
        state.current = organization
        setItem('current', organization)
    },
    [USER_SET] (state, user) {
        state.userProfile = user
        setItem('user', user)
    },
    [CLEAN_STATE] (state) {
        setItem('organizations', [])
        setItem('current', [])
        setItem('user', [])
    }
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
    [AUTH_REQUEST]: ({commit, dispatch}, user) => {
        commit(CLEAN_STATE)
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            commit(AUTH_REQUEST)
            axios.post('/api/v2/login', user)
                .then(resp => {
                    const organizations = resp.data.organizations
                    commit(ORGANIZATION_SUCCESS, {
                        organizations: organizations
                    })
                    commit(AUTH_SUCCESS)
                    // you have your token, now log in your user :)
                    // dispatch(USER_REQUEST)
                    resolve(resp)
                })
                .catch(err => {
                    commit(AUTH_ERROR, err)
                    reject(err)
                })
        })
    },
    [LOGOUT_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(LOGOUT_REQUEST)
            commit(CLEAN_STATE)
            axios.post('/api/v2/login?logout=1')
                .then(resp => {
                    commit(LOGOUT_SUCCESS)
                    resolve(resp)
                })
                .catch(err => {
                    commit(AUTH_ERROR, err)
                    reject(err)
                })
        })
    },
    /**
     * @deprecated
     * @param commit
     * @param dispatch
     * @param lang
     * @returns {*}
     */
    [LANGUAGE_REQUEST]: ({commit, dispatch}, lang) => {
        return getLanguage(lang)
    },
    [HEATMAP_REQUEST]: ({commit, dispatch}, organization = null) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/v2/heatmap/${organization}`).then(resp => {
                resolve(resp)
            }).catch(handleError(reject))
        })
    },
    [DASHBOARD_REQUEST]: ({commit, dispatch}, request) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/v2/structure/${request.organization}`, {params: request}).then(resp => {
                resolve(resp)
            }).catch(handleError(reject))
        })
    },
    [BUILDING_REQUEST]: ({commit, dispatch}, request) => {
        const id = state.current.id
        return new Promise((resolve, reject) => {
            if (request) {
                axios.post(`/api/v2/building/${id}`, request)
                    .then(resolve)
                    .catch(handleError(reject))
            } else {
                axios.get(`/api/v2/building/${id}`)
                    .then(resolve)
                    .catch(handleError(reject))
            }
        })
    },
    [HOMEBASE_REQUEST]: ({commit, dispatch}, request) => {
        const id = state.current.id
        if (request) {
            if (request.action === 'destroy') {
                return new Promise((resolve, reject) => {
                    axios.delete(`/api/v2/homebase?organization=${id}&homebase=${request.homebase}`, request)
                        .then(resolve)
                        .catch(handleError(reject))
                })
            }
            return new Promise((resolve, reject) => {
                axios.post(`/api/v2/homebase?organization=${id}`, request)
                    .then(resolve)
                    .catch(handleError(reject))
            })
        } else {
            return new Promise((resolve, reject) => {
                axios.get(`/api/v2/homebase?organization=${id}`)
                    .then(resolve)
                    .catch(handleError(reject))
            })
        }
    },
    [VALVE_REQUEST]: ({commit, dispatch}, request) => {
        const id = state.current.id
        if (request && typeof request.type === 'undefined') {
            return new Promise((resolve, reject) => {
                request.organization = id
                axios.put(`/api/v2/valve`, request)
                    .then(resolve)
                    .catch(handleError(reject))
            })
        } else {
            return new Promise((resolve, reject) => {
                let url = `/api/v2/valve?organization=${id}`
                if (request) {
                    url = `/api/v2/valve?organization=${id}&type=max&transmitter=${request.transmitter}`
                }
                axios.get(url)
                    .then(resolve)
                    .catch(handleError(reject))
            })
        }
    },
    [VALVE_ALARM_REQUEST]: ({commit, dispatch}, request) => {
        const id = state.current.id
        if (request && request.action === 'add') {
            request.organization = id
            return new Promise((resolve, reject) => {
                axios.post(`/api/v2/notification-valve-subscribers?organization=${id}`, request)
                    .then(resolve)
                    .catch(handleError(reject))
            })
        } else if (request && request.action === 'delete') {
            request.organization = id
            return new Promise((resolve, reject) => {
                axios.delete(`/api/v2/notification-valve-subscribers?organization=${id}&email=` + decodeURIComponent(request.email))
                    .then(resolve)
                    .catch(handleError(reject))
            })
        } else {
            return new Promise((resolve, reject) => {
                let url = `/api/v2/notification-valve-subscribers?organization=${id}`
                if (request) {
                    url = `/api/v2/notification-valve-subscribers?organization=${id}`
                }
                axios.get(url)
                    .then(resolve)
                    .catch(handleError(reject))
            })
        }
    },
    [UNIT_REQUEST]: ({commit, dispatch}, request) => {
        const id = state.current.id
        return new Promise((resolve, reject) => {
            axios.post(`/api/v2/unit/${id}`, request)
                .then(resolve)
                .catch(handleError(reject))
        })
    },
    [TRANSMITTERS_REQUEST]: ({commit, dispatch}, request) => {
        const id = state.current.id
        if (request) {
            return new Promise((resolve, reject) => {
                axios.post(`/api/v2/transmitter`, request)
                    .then(resolve)
                    .catch(handleError(reject))
            })
        } else {
            return new Promise((resolve, reject) => {
                axios.get(`/api/v2/transmitter?organization=${id}`)
                    .then(resolve)
                    .catch(handleError(reject))
            })
        }
    },
    [ELECTRICITY_METERS]: ({commit, dispatch}, request) => {
        const id = state.current.id
        return new Promise((resolve, reject) => {
            axios.get(`/api/v2/electricity-meter?organization=${id}`)
                .then(resolve)
                .catch(handleError(reject))
        })
    },
    [GAS_METERS]: ({commit, dispatch}, request) => {
        const id = state.current.id
        return new Promise((resolve, reject) => {
            axios.get(`/api/v2/gas-meter?organization=${id}`)
                .then(resolve)
                .catch(handleError(reject))
        })
    },
    [HEAT_METERS]: ({commit, dispatch}, request) => {
        const id = state.current.id
        return new Promise((resolve, reject) => {
            axios.get(`/api/v2/heat-meter?organization=${id}`)
                .then(resolve)
                .catch(handleError(reject))
        })
    },
    [WATER_METERS]: ({commit, dispatch}, request) => {
        const id = state.current.id
        return new Promise((resolve, reject) => {
            axios.get(`/api/v2/water-meter?organization=${id}`)
                .then(resolve)
                .catch(handleError(reject))
        })
    },
    [TREE_REQUEST]: ({commit, dispatch}) => {
        const id = state.current.id
        return new Promise((resolve, reject) => {
            axios.get(`/api/v2/tree/${id}`)
                .then(resolve)
                .catch(handleError(reject))
        })
    },
    [ORGANIZATION_REQUEST]: ({commit, dispatch}, request) => {
        return new Promise((resolve, reject) => {
            if (request.action === 'create') {
                axios.post('/api/v2/organization', request)
                    .then(resp => {
                        commit(ORGANIZATION_SUCCESS, {
                            organizations: resp.data.organizations
                        })
                        resolve(resp)
                    })
                    .catch(handleError(reject))
            } else if (request.action === 'read') {
                let setCurrent = !!(typeof request.current == 'undefined' || request.current);
                axios.get('/api/v2/organization' + (request.id ? '/' + request.id : ''), {
                    skipAuthRedirect: request.ignoreRedirect === true
                })
                    .then(resp => {
                        if (resp.data.organizations) {
                            commit(ORGANIZATION_SUCCESS, {
                                organizations: resp.data.organizations,
                                setCurrent: setCurrent
                            })
                        }
                        resolve(resp)
                    })
                    .catch(handleError(reject, request.ignoreRedirect))
            } else if (request.action === 'update') {
                axios.put(`/api/v2/organization/${request.id}`, request)
                    .then(resp => {
                        if (resp.data.organizations) {
                            commit(ORGANIZATION_SUCCESS, {
                                organizations: resp.data.organizations,
                                setCurrent: true
                            })
                        }
                        resolve(resp)
                    })
                    .catch(handleError(reject))
            }
        })
    },
    [REG_REQUEST]: ({commit, dispatch}, request) => {
        commit(CLEAN_STATE)
        return new Promise((resolve, reject) => {
            axios.post('/api/v2/signup', request)
                .then(resp => {
                    commit(AUTH_SUCCESS)
                    commit(ORGANIZATION_SUCCESS, {
                        organizations: resp.data.organizations
                    })
                    resolve(resp)
                })
                .catch(handleError(reject))
        })
    },
    [SHARE_REQUEST]: ({commit, dispatch}, request) => {
        if (request.action === 'read') {
            return new Promise((resolve, reject) => {
                axios.get('/api/v2/share', {params: request})
                    .then(resolve)
                    .catch(handleError(reject))
            })
        } else if (request.action === 'create' || request.action === 'resend') {
            return new Promise((resolve, reject) => {
                axios.post('/api/v2/share', request)
                    .then(resolve)
                    .catch(handleError(reject))
            })
        } else if (request.action === 'destroy') {
            return new Promise((resolve, reject) => {
                axios.delete('/api/v2/share/' + request.id)
                    .then(resolve)
                    .catch(handleError(reject))
            })
        }
    },
    [TIMEZONE_REQUEST]: ({commit, dispatch}) => {
        if (!timezones) {
            timezones = new Promise((resolve, reject) => {
                axios.get('/api/v2/timezone')
                    .then(resolve)
                    .catch(handleError(reject))
            })
        }
        return timezones
    },
    [USER_REQUEST]: ({commit, dispatch}, request) => {
        return new Promise((resolve, reject) => {
            if (request.action === 'read') {
                axios.get('/api/v2/user-data')
                    .then(resp => {
                        if (typeof resp.data.organization != 'undefined') {
                            const organizations = resp.data.organizations
                            commit(ORGANIZATION_SUCCESS, {
                                organizations: organizations
                            })
                        }
                        commit(USER_SET, resp.data.data)
                        resolve(resp)
                    })
                    .catch(handleError(reject))
            } else if (request.action === 'create') {
                axios.post('/api/v2/user-data', request)
                    .then(resp => {
                        commit(USER_SET, resp.data.data)
                        resolve(resp)
                    })
                    .catch(handleError(reject))
            } else {
                reject(new Error('unsupported operation'))
            }
        })
    },
    [ALARM_REQUEST]: ({commit, dispatch}, request) => {
        return new Promise((resolve, reject) => {
            const id = request.data && request.data.id ? request.data.id : ''
            const baseUrl = `/api/v2/alarm/${id}?entity=${request.entity}&type=${request.type}&water=${request.water}`
            if (request.action === 'read') {
                axios.get(baseUrl)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(handleError(reject))
            } else if (request.action === 'create') {
                axios.post(baseUrl, request.data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(handleError(reject))
            } else if (request.action === 'destroy') {
                axios.delete(baseUrl + '&alarm_type=' + request.data.type)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(handleError(reject))
            } else {
                reject(new Error('unsuported operation'))
            }
        })
    },
    [ALERT_REQUEST]: ({commit, dispath}, request) => {
        return new Promise((resolve, reject) => {
            const baseUrl = `/api/v2/alert`
            if (request.action === 'read') {
                const all = request.all ? 1 : 0
                const limit = request.limit
                const page = request.page
                let url = `${baseUrl}?all=${all}`
                if (limit > 0) {
                    url += `&limit=${limit}`
                }
                if (page > 0) {
                    url += `&page=${page}`
                }
                axios.get(url)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(handleError(reject))
            } else if (request.action === 'update') {
                let url = baseUrl;
                if (request.id) {
                    url += `/${request.id}`
                }
                axios.put(url, request.request)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(handleError(reject))
            }
        })
    },
    [CHECK_API]: ({commit, dispatch}, serialNumber) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/v2/check/${serialNumber}`).then(resp => {
                resolve(resp)
            }).catch(handleError(reject))
        })
    },
    [OPEN_VALVE_API]: () => {
        return new Promise((resolve, reject) => {
            axios.post('/api/v2/valve-open').then(resp => {
                resolve(resp)
            }).catch(handleError(reject))
        })
    }
}

// getters are functions
const getters = {
    isAuthenticated: state => state.login,
    menu: state => state.userProfile.m,
    authStatus: state => state.status,
    activeOrganization: (state) => {
        return state.current
    },
    hasOrganization: hasOrganization,
    language: () => getLanguage(),
    availableOrganizations: state => state.organizations,
    activeUser: state => state.userProfile
}

export default createStore({
    state,
    getters,
    actions,
    mutations,
    modules: {
        disbursement,
        entity,
        user,
        tree
    }
})

export {
    AUTH_REQUEST,
    LOGOUT_REQUEST,
    SESSION_EXPIRED,
    LANGUAGE_REQUEST,
    HEATMAP_REQUEST,
    DASHBOARD_REQUEST,
    BUILDING_REQUEST,
    HOMEBASE_REQUEST,
    VALVE_REQUEST,
    VALVE_ALARM_REQUEST,
    UNIT_REQUEST,
    TRANSMITTERS_REQUEST,
    ELECTRICITY_METERS,
    GAS_METERS,
    HEAT_METERS,
    WATER_METERS,
    ORGANIZATION_REQUEST,
    ORGANIZATION_SET,
    TREE_REQUEST,
    REG_REQUEST,
    SHARE_REQUEST,
    TIMEZONE_REQUEST,
    USER_REQUEST,
    SHOW_UNIT,
    ALARM_REQUEST,
    ALERT_REQUEST,
    CHECK_API,
    OPEN_VALVE_API
}
